import "./InfoDropdownListItem.scss"

import { FC } from "react"

interface IInfoDropdownListItemLinkProps {
    href: React.AnchorHTMLAttributes<HTMLAnchorElement>["href"]
    target?: React.AnchorHTMLAttributes<HTMLAnchorElement>["target"]
    download?: React.AnchorHTMLAttributes<HTMLAnchorElement>["download"]
    disabled?: boolean
    onClick?: () => void
}

const InfoDropdownListItemLink: FC<React.PropsWithChildren<IInfoDropdownListItemLinkProps>> = ({
    href,
    target,
    download,
    disabled,
    children,
    onClick,
}) => {
    if (!href || disabled) {
        return (
            <div className="info-dropdown-list-item info-dropdown-list-item--link info-dropdown-list-item--disabled">
                {children}
            </div>
        )
    }

    return (
        <a href={href}
            onClick={onClick}
            target={target}
            download={download}
            rel={target === "_blank" ? "noreferrer" : undefined}
            className="info-dropdown-list-item info-dropdown-list-item--link">
            {children}
        </a>
    )
}

export default InfoDropdownListItemLink
